import React, { useEffect, useState } from 'react';
import { database } from '../firebaseConfig';
import { ref, onValue } from 'firebase/database';

// Marketing links for this transaction: feature cards, brochures, mailers, and the feature and upgrade list.
// Each link is saved automatically when it's sent through its task.
const MarketingLinks = ({ transactionId }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!transactionId) return undefined;
    const unsub = onValue(ref(database, `transactions/${transactionId}/marketingLinks`), (snap) => {
      const val = snap.val() || {};
      setItems(Object.entries(val).map(([key, v]) => ({ key, ...v })).sort((a, b) => String(a.label).localeCompare(String(b.label))));
    }, (err) => console.error('Could not load marketing links', err));
    return () => unsub();
  }, [transactionId]);

  const linkStyle = { color: '#8C6D1F', fontWeight: 600, wordBreak: 'break-all' };

  return (
    <div style={{ margin: '16px 0' }}>
      <button type="button" onClick={() => setOpen(!open)}
        style={{ background: '#fff', color: '#1a1a1a', border: '1px solid #d8c9a8', padding: '8px 14px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', fontSize: 14 }}>
        {open ? 'Hide marketing files' : `Marketing files (${items.length})`}
      </button>
      {open && (
        <div style={{ marginTop: 12 }}>
          {items.length === 0 && <p style={{ color: '#7f7f7f', fontSize: 14 }}>No marketing links have been sent for this transaction yet.</p>}
          {items.map((m) => (
            <div key={m.key} style={{ border: '1px solid #e7dfcc', borderRadius: 8, padding: 12, marginBottom: 8, background: '#fff' }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>{m.label}</div>
              <a href={m.url} target="_blank" rel="noreferrer" style={linkStyle}>{m.url}</a>
              {m.savedAt && <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>Saved {new Date(m.savedAt).toLocaleString()}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MarketingLinks;
